<template>
  <div style="min-height: 100vh;">
    <div class="container">
      <transition-group
        tag="div"
        name="list"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
        appear
      >
        <GymCard v-for="gym in gyms.slice(0, 5)" :key="gym.id" :gym="gym" />
      </transition-group>
      <transition-group
        tag="div"
        name="list"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
        appear
      >
        <QuickGripAd key="QuickGripAd" />
      </transition-group>
      <transition-group
        tag="div"
        name="list"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
        appear
      >
        <GymCard v-for="gym in gyms.slice(5, 10)" :key="gym.id" :gym="gym" />
      </transition-group>
      <FreePassForm  />
    </div>
    <transition name="slide-up">
      <Notification v-if="notificationActive" class="notification" message="Review Submitted!" />
    </transition>
  </div>
</template>

<script>
import GymCard from "@/components/molecules/GymCard.vue";
import FreePassForm from "@/components/organisms/FreePassForm.vue"
import Notification from "@/components/atoms/Notification";
import QuickGripAd from "@/components/organisms/advertisements/QuickGripAd.vue";
import Velocity from "velocity-animate";
import { mapState } from "vuex";
export default {
  components: {
    FreePassForm,
    QuickGripAd,
    GymCard,
    Notification
  },
  computed: {
    ...mapState(["notificationActive", "filterSidebar", "facilities", "gyms"])
  },
  methods: {
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      let delay = el.dataset.index * 200;
      setTimeout(function() {
        Velocity(el, { opacity: 1, height: `100%` }, { complete: done });
      }, delay);
    },
    leave(el, done) {
      let delay = el.dataset.index * 200;
      setTimeout(function() {
        Velocity(el, { opacity: 0, height: 0 }, { complete: done });
      }, delay);
    }
  }
};
</script>

<style scoped>
i {
  font-size: 2rem;
  margin: 0 2rem;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.2s ease;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(200px);
}
</style>
